import axios from 'axios';
import { UPLOADS_API } from '../env.config.js';

/**
 * Uploads a file to the file_uploads endpoint
 * @param {Object} coreToken - The core token object with token
 * @param {File} file - The file to upload
 * @param {string} recordId - The widget submission ID
 * @param {string} recordType - The record type (e.g., "WidgetSubmission")
 * @returns {Promise} Axios response
 */
const uploadFile = async (coreToken, file, recordId, recordType) => {
  const baseURL = UPLOADS_API;
  const formData = new FormData();

  formData.append('data', file);
  formData.append('record_id', recordId);
  formData.append('record_type', recordType);

  try {
    const response = await axios.post(
      'file_uploads',
      formData,
      {
        baseURL,
        headers: {
          Authorization: `Bearer ${coreToken.token}`,
          'X-Application-Source': 'widgets',
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response;
  } catch (error) {
    return error;
  }
};

export default uploadFile;

